import styled from '@emotion/styled';
import { Paper } from '@mui/material';
import color from 'src/theme/color';

export const DescriptionContent = styled.div`
    white-space: pre-wrap;
    color: ${color.white};
    text-align: left;
    line-height: 1.6;
    min-height: 100px;
    max-height: none;
    overflow-y: visible;
    position: relative;
    padding-bottom: 40px;
`;

export const MarkdownContainer = styled.div`
    color: ${color.white};
`;

export const EditButtonContainer = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 1;
`;

export const EditIconButton = styled.div`
    color: ${color.white};
    background-color: ${color.white10};

    &:hover {
        background-color: rgba(255, 255, 255, 0.2);
    }
`;

export const ActionButtonsContainer = styled.div`
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 16px;
`;

export const ActionButton = styled.button<{ variant: 'cancel' | 'confirm' }>`
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 500;
    color: ${color.white};
    background-color: ${(props) =>
        props.variant === 'cancel' ? color.blackRock : color.lightningYellow};
    border: none;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.2s ease;
    min-width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background-color: ${(props) =>
            props.variant === 'cancel' ? color.darkGray : color.yellow60};
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const AttachmentsSection = styled.div`
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid ${color.white10};
`;

export const AttachmentsGrid = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
    max-height: 150px;
    overflow-y: auto;
`;

export const TextFieldContainer = styled.div`
    margin-bottom: 16px;

    .mdx-editor-container {
        overflow: hidden;
    }
`;

export const CloseIconStyles = {
    color: color.white
};

export const EditIconButtonStyles = {
    color: color.white,
    backgroundColor: color.white10,
    '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.2)'
    }
};

export const StyledDescriptionDialogPaper = styled(Paper)({
    backgroundColor: color.darkBlue,
    color: color.white,
    padding: '20px',
    borderRadius: '8px',
    margin: '16px',
    minWidth: '700px',
    position: 'relative'
});

export const EditModeAttachmentsContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
    margin-bottom: 16px;
`;
